import { useSnapshot } from 'valtio'
import { type FormEvent, type ReactElement, useEffect } from 'react'
import { SlideOver } from '../ui/SlideOver'
import { GtagEvents, gtmTrackButtonPress } from '../../utils/gtmUtils'
import {
  resetCustomerAddProxy,
  customerAddProxy
} from './customerAddProxy'

import { CustomerSectionSlideContents } from './CustomerSectionSlideContents'

const cancelFunction = (): void => {
  customerAddProxy.displaySlideOver = false
  gtmTrackButtonPress(GtagEvents.CUSTOMER_MODAL_CANCEL)
  resetCustomerAddProxy()
}

interface Props {
  submitFunction: (e: FormEvent<HTMLFormElement>) => Promise<void>
}
export function CustomerAddSlideOver ({ submitFunction }: Props): ReactElement {
  const { displaySlideOver, allowSubmit } = useSnapshot(customerAddProxy)
  useEffect(() => resetCustomerAddProxy, [])
  return (
    <SlideOver
      submitText="Save Customer"
      canSubmit={allowSubmit}
      isOpen={displaySlideOver}
      title="Add New Customer"
      cancelFunction={cancelFunction}
      submitFunction={submitFunction}
    >
      <CustomerSectionSlideContents />
    </SlideOver>
  )
}
